import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import { SUPPORTED_LANGUAGES } from "shared/locale/constants";

// lang picks Japanese rather than Chinese glyphs for shared kanji, and sets the
// screen reader voice and spellcheck language.
i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: [...SUPPORTED_LANGUAGES],
    debug: process.env.NODE_ENV === "development",
    interpolation: { escapeValue: false },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    ns: ["common", "duck", "filters", "pages", "schema", "superadmin"],
    defaultNS: "common",
    detection: {
      order: ["localStorage"],
      caches: ["localStorage"],
      // The last shown language, so the next load doesn't flash English. Unlike
      // USER_LANG_KEY, which holds only an explicit user choice.
      lookupLocalStorage: "lang",
    },
  });
